<template>
    <div class="search-results__card">
        <div class="search-results__card--header-section">
            <div class="search-results__card--header-section--title">
                {{ result.front_end_position }}
            </div>
        </div>
        <div class="search-results__card--inner">
            <div class="search-results__card--inner--details">
                <div class="search-results__card--inner--details--item">
                    <div class="search-results__card--inner--details--item--image">
                        <img src="/images/careers/location-icon.svg" alt="logo" />
                    </div>
                    <span>
                        {{ result.dealership != null ? result.dealership.name : "N\A"}}
                    </span>
                </div>
                <div class="search-results__card--inner--details--item">
                    <div class="search-results__card--inner--details--item--image">
                        <img src="/images/careers/contract-icon.svg" alt="logo" />
                    </div>
                    <span>
                        {{ result.employment_type_text }}
                    </span>
                    </div>
                <div class="search-results__card--inner--details--item">
                    <div class="search-results__card--inner--details--item--image">
                        <img src="/images/careers/salary-icon.svg" alt="logo" />
                    </div>
                    <span v-html="result.salary_for_site"></span>
                </div>
            </div>
            <div></div>
            <div class="search-results__card--inner--buttons">
                <a :href="resultLink" type="button" class="link link--is-button link--has-icon link--centered">Apply Online
                </a>
                <a v-if="shareOptionsOpen != index" @click="toggleShareOptions(index)" class="link link--is-button link--secondary link--has-share-icon  link--centered">Share</a>
                <div v-if="shareOptionsOpen === index" class="share-container">
                    <a @click="closeShare(index)" class="share-container--close link--secondary">&#10006;</a>
                    <div class="share-container__options">
                        <a :href="shareViaEmail"><img src="/images/careers/email.svg" alt="Email" /></a>
                        <a :href="shareViaFacebook" target="_blank" rel="noopener"><img src="/images/careers/facebook-social.svg" alt="Facebook" /></a>
                        <!-- <a :href="shareViaLinkedIn"><img src="/images/careers/linkedin.svg" alt="LinkedIn" /></a> -->
                        <a :href="shareViaWhatsApp" target="_blank" rel="noopener"><img src="/images/careers/whatsapp.svg" alt="WhatsApp" /></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: [
        'result',
        'index',
        'result_url'
        ],

    data() {
        return {
            shareOptionsOpen: null,
        };
    },

    methods:{
        toggleShareOptions(index) {
            if(this.shareOptionsOpen === index){
                this.shareOptionsOpen = null
            }else{
                this.shareOptionsOpen = index
            }
        },

        closeShare(index) {
            this.shareOptionsOpen = null;
        },

        shareContent(jobId, shareBaseUrl) {
            const shareLink = this.result_url.replace('?', jobId);
            const encodedLink = encodeURIComponent(shareLink);
            return shareBaseUrl + encodedLink;
        },
    },

    computed: {
        shareViaEmail() {
            const subject = 'Check out this job opportunity';
            const body = `I found a job opportunity that you might be interested in: ${this.result_url.replace('?', this.result.id)}`;
            const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
            return mailtoLink;
        },

        shareViaFacebook() {
            const shareBaseUrl = 'https://www.facebook.com/sharer/sharer.php?u=';
            return this.shareContent(this.result.id, shareBaseUrl);
        },

        shareViaWhatsApp() {
            const shareBaseUrl = 'whatsapp://send?text=';
            return this.shareContent(this.result.id, shareBaseUrl);
        },

        resultLink() {
            return this.result_url.replace('?', this.result.id);
        }
    }
}

</script>




// WEBPACK FOOTER //
// resources/assets/js/careers/components/CareersResultsCard.vue